import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { DataWithPaginationInterface } from 'shared/types/pagination-interface';
import useSWR from 'swr';
import { INTEGRATIONS_API } from '../api';
import { IntegrationInterface } from '../types';
export const useIntegrations = () => {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: fetchIntegrations
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => user && `${INTEGRATIONS_API}/zoom-integration/user/integrations`;
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    mutate
  } = useSWR(t1, fetchIntegrations);
  let t2;
  if ($[3] !== data || $[4] !== mutate) {
    t2 = {
      data,
      mutate
    };
    $[3] = data;
    $[4] = mutate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};